import signUp from "../../assets/Images/signup.png";
import classes from "./Login.module.scss";
import { Formik, useFormik } from "formik";
import { signinMobileSchema, signinEmailSchema } from "../../Schemas/Schemas";

import { Link, useNavigate } from "react-router-dom";
// import { IAdminLogin } from "../../Utils/dtos";
// import { AdminLoginAPICall, ProfileDetailsAPICall } from "../../Utils/APICalls";
import ErrorSnackBar from "../../components/SnackBar/ErrorSnackBar";
import Logo from "../../assets/Images/firstockLogo.svg";
import icon1 from "../../assets/Images/icon1.svg";
import icon2 from "../../assets/Images/icon2.svg";
import icon3 from "../../assets/Images/icon3.svg";
import icon4 from "../../assets/Images/icon4.svg";
import ellipse from "../../assets/Images/Ellipse.svg";
import { LoadingButton } from "@mui/lab";
import { useEffect, useState } from "react";
import { Button, Divider, TextField } from "@mui/material";
import { introducerLoginAPICall } from "../../Utils/APICalls";
import { IIntroducerLogin } from "../../Utils/dtos";

const initialMobileValues = {
  mobile: "",
};
const initialEmailValues = {
  email: "",
};

const Login = () => {
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState("");
  const [showAccountNumber, setShowAccountNumber] = useState(false);
  const [loading, setLoading] = useState(false);
  const [mobileLogin, setMobileLogin] = useState(true);
  const [emailLogin, setEmailLogin] = useState(false);
  const [hoverEffect, setHoverEffect] = useState(true);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [apiErrorMessage, setAPIErrorMessage] = useState("");
  const hoverData = [
    {
      title: "Lucrative Commissions",
      icon: icon1,
    },
    {
      title: "Dedicated Support",
      icon: icon2,
    },
    {
      title: "Diverse Opportunities",
      icon: icon3,
    },
    {
      title: "Interactive dashboard",
      icon: icon4,
    },
  ];

  const handleMobileLogin = () => {
    setMobileLogin(true);
    setEmailLogin(false);
  };
  const handleEmailLogin = () => {
    setMobileLogin(false);
    setEmailLogin(true);
  };

  const handleClickShowAccountNumber = () =>
    setShowAccountNumber((show) => !show);

  const handleMouseDownAccountNumber = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % hoverData.length);
      setHoverEffect(true);

      setTimeout(() => {
        setHoverEffect(false);
      }, 1500);
    }, 2000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  const handleLoginViaMobile = (values: any) => {
    setLoading(true);
    let obj: IIntroducerLogin = {
      introducer_details: values.mobile,
    };
    introducerLoginAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;
        sessionStorage.setItem("introducerDetails", values.mobile);
        navigate("/otpScreen");
        setLoading(false);
      })
      .catch((error: any) => {
        // console.log("error", error);
        setLoading(false);
        if (error && error.response.data.error.message) {
          setAPIErrorMessage(error.response.data.error.message);
          setTimeout(() => {
            setAPIErrorMessage("");
          }, 5000);
        }
      });
  };
  const handleLoginViaEmail = (values: any) => {
    setLoading(true);
    let obj: IIntroducerLogin = {
      introducer_details: values.email,
    };
    introducerLoginAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;
        sessionStorage.setItem("introducerDetails", values.email);
        navigate("/otpScreen");
        setLoading(false);
      })
      .catch((error: any) => {
        // console.log("error", error);
        setLoading(false);
        if (error && error.response.data.error.message) {
          setAPIErrorMessage(error.response.data.error.message);
          setTimeout(() => {
            setAPIErrorMessage("");
          }, 5000);
        }
      });
  };

  return (
    <>
      <div className={classes.container}>
        <div className={classes.modal}>
          <div className={classes.modalContainer}>
            <div className={classes.modalLeft}>
              <div className={classes.companyLogo}>
                {/* <img src={Logo} className={classes.Logo} /> */}
                <p
                  className={classes.Logo}
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    navigate("/home");
                  }}
                >
                  FIRSTOCK
                </p>
              </div>
              <div className={classes.CompanyTitleSection}>
                <p className={classes.CompanyTitle}>Welcome to Firstock</p>
                <p className={classes.CompanyDesc}>
                  Select the suitable method to access your Firstock account.
                </p>
              </div>

              <div className={classes.loginData}>
                {mobileLogin && (
                  <Formik
                    validationSchema={signinMobileSchema}
                    initialValues={initialMobileValues}
                    onSubmit={(values: any) => {
                      // console.log("values", values);
                      // handleUpdateDate(values);
                      handleLoginViaMobile(values);
                    }}
                  >
                    {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleBlur,
                      handleSubmit,
                      setFieldValue,
                    }) => {
                      // console.log("errors", errors);
                      // console.log("values", values);
                      return (
                        <>
                          <form noValidate onSubmit={handleSubmit}>
                            <div className={classes.inputBlock}>
                              <TextField
                                name="mobile"
                                id="mobile"
                                placeholder="Enter Your Mobile Number"
                                value={values.mobile}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                inputProps={{
                                  maxLength: 10,
                                  inputMode: "numeric",
                                  pattern: "[0-9]*",
                                }}
                                onKeyPress={(event) => {
                                  const keyCode = event.keyCode || event.which;
                                  const keyValue = String.fromCharCode(keyCode);
                                  const isValidKey = /^\d+$/.test(keyValue);

                                  if (!isValidKey) {
                                    event.preventDefault();
                                  }
                                }}
                                error={touched.mobile && Boolean(errors.mobile)}
                                helperText={
                                  touched.mobile && errors.mobile?.toString()
                                }
                              />
                              {/* 
                              {errors.mobile && touched.mobile ? (
                                <p className={classes.formError}>
                                  {errors.mobile}
                                </p>
                              ) : null} */}
                            </div>

                            <div className={classes.modalButtons}>
                              <LoadingButton
                                type="submit"
                                loading={loading}
                                fullWidth
                                style={{ padding: "10px 50px" }}
                                sx={{
                                  bgcolor: loading
                                    ? "#157384"
                                    : "rgba(0, 103, 121, 1)",
                                  color: "white",
                                  textTransform: "none",
                                  borderRadius: "10px",
                                  "&:hover": {
                                    // border: "1px solid rgba(119, 193, 85, 1)",
                                    background: "rgba(0, 103, 121, 1)",
                                    color: "white",
                                  },
                                }}

                                // disabled={values.mobile.length < 10}
                              >
                                Continue with Mobile
                              </LoadingButton>
                              {/* <a href="#" className={classes.link}>
                                <Link
                                  to={"/forgotPassword"}
                                  style={{ textDecoration: "none" }}
                                >
                                  Forgot Password?
                                </Link>
                              </a> */}
                            </div>
                          </form>
                        </>
                      );
                    }}
                  </Formik>
                )}
                {emailLogin && (
                  <Formik
                    validationSchema={signinEmailSchema}
                    initialValues={initialEmailValues}
                    onSubmit={(values: any) => {
                      // console.log("values", values);
                      // handleUpdateDate(values);
                      handleLoginViaEmail(values);
                      // navigate("/otpScreen");
                    }}
                  >
                    {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleBlur,
                      handleSubmit,
                      setFieldValue,
                    }) => {
                      // console.log("errors", errors);
                      // console.log("values", values);
                      return (
                        <>
                          <form noValidate onSubmit={handleSubmit}>
                            <div className={classes.inputBlock}>
                              <TextField
                                name="email"
                                id="email"
                                placeholder="Enter Your Email Id"
                                value={values.email}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={touched.email && Boolean(errors.email)}
                                helperText={
                                  touched.email && errors.email?.toString()
                                }
                              />
                            </div>

                            <div className={classes.modalButtons}>
                              <LoadingButton
                                type="submit"
                                loading={loading}
                                style={{ padding: "10px 50px" }}
                                sx={{
                                  bgcolor: loading
                                    ? "#157384"
                                    : "rgba(0, 103, 121, 1)",
                                  color: "white",
                                  textTransform: "none",
                                  borderRadius: "10px",
                                  "&:hover": {
                                    // border: "1px solid rgba(119, 193, 85, 1)",
                                    background: "rgba(0, 103, 121, 1)",
                                    color: "white",
                                  },
                                }}
                              >
                                Continue with Email
                              </LoadingButton>
                            </div>
                          </form>
                        </>
                      );
                    }}
                  </Formik>
                )}
                <div className={classes.modalButtons}>
                  {!mobileLogin && (
                    <>
                      {emailLogin && <Divider> or </Divider>}
                      <Button
                        style={{ padding: "10px 50px" }}
                        sx={{
                          background: "rgba(0, 103, 121, 1)",
                          color: "white",
                          borderRadius: "10px",
                          textTransform: "none",
                          "&:hover": {
                            background: "rgba(0, 103, 121, 1)",
                            color: "white",
                          },
                        }}
                        onClick={handleMobileLogin}
                        // variant="outlined"
                      >
                        Login via Mobile
                      </Button>
                    </>
                  )}

                  {!emailLogin && (
                    <>
                      {" "}
                      <Divider> or </Divider>
                      <Button
                        style={{ padding: "10px 50px" }}
                        sx={{
                          // border: "1px solid rgba(119, 193, 85, 1)",
                          color: "white",
                          borderRadius: "10px",
                          textTransform: "none",
                          background: "rgba(0, 103, 121, 1)",
                          "&:hover": {
                            color: "white",
                            background: "rgba(0, 103, 121, 1)",
                          },
                        }}
                        onClick={handleEmailLogin}
                        // variant="outlined"
                      >
                        Login via Email
                      </Button>
                    </>
                  )}
                </div>
                <div className={classes.resendSection}>
                  <p className={classes.clickhere}>Don't have an account?</p>
                  <a
                    // target="_blank"
                    style={{ textDecoration: "underline" }}
                    className={classes.change}
                    onClick={() => {
                      navigate("/mobile");
                    }}
                  >
                    SignUp
                  </a>
                </div>
              </div>
            </div>
            <ErrorSnackBar message={apiErrorMessage} />
            {/* <div className={classes.modalRight}>
              <div className={classes.modalRightHeader}>
                <p className={classes.modalRightHeaderTitle}>
                  Our <span style={{ fontWeight: 600 }}>Features</span>{" "}
                  Specially For you
                </p>
              </div>
              {hoverData.map((a: any, index: any) => (
                <div
                  className={classes.modalRightHoverSection}
                  style={{
                    background:
                      index === currentIndex && hoverEffect
                        ? "linear-gradient(to right,rgba(0, 103, 121, 1),rgba(217, 217, 217, 0) ) left"
                        : "",
                    transform:
                      index === currentIndex && hoverEffect
                        ? "translateX(10%)"
                        : "",
                  }}
                >
                  <div className={classes.modalRightHoverImageSection}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <img
                        src={ellipse}
                        style={{
                          width: "60%",
                          position: "absolute",
                          left: "-6px",
                        }}
                      />
                      <img
                        src={a.icon}
                        style={{
                          width: index === 0 ? "30px" : "22px",
                          position: "absolute",
                          left: index === 0 ? "17px" : "20px",
                        }}
                      />
                    </div>
                  </div>
                  <div>
                    <p className={classes.modalRightHoverText}>{a.title}</p>
                  </div>
                </div>
              ))}
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
